"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = (0, _styledSystem.style)({
  prop: 'outlineWidth',
  key: 'space'
});
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzdHlsZSIsInByb3AiLCJrZXkiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY3VzdG9tUHJvcHMvb3V0bGluZVdpZHRoLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHN0eWxlIH0gZnJvbSAnc3R5bGVkLXN5c3RlbSc7XG5cbmV4cG9ydCBkZWZhdWx0IHN0eWxlKHsgcHJvcDogJ291dGxpbmVXaWR0aCcsIGtleTogJ3NwYWNlJyB9KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBc0MsZUFFdkIsSUFBQUEsbUJBQUssRUFBQztFQUFFQyxJQUFJLEVBQUUsY0FBYztFQUFFQyxHQUFHLEVBQUU7QUFBUSxDQUFDLENBQUM7QUFBQSJ9